import { render, staticRenderFns } from "./Pesquisa.vue?vue&type=template&id=23d9139b"
import script from "./Pesquisa.vue?vue&type=script&lang=js"
export * from "./Pesquisa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23d9139b')) {
      api.createRecord('23d9139b', component.options)
    } else {
      api.reload('23d9139b', component.options)
    }
    module.hot.accept("./Pesquisa.vue?vue&type=template&id=23d9139b", function () {
      api.rerender('23d9139b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pesquisa/Pesquisa.vue"
export default component.exports